// extracted by mini-css-extract-plugin
export default {"SwipeLeftToClose":"bew_a bhr_bk bhr_bl bhr_bo","SwipeLeftToClose--animating":"bew_b"};